import type { Location, LocationsQuery } from '@partou/my-group/data';
import { Injectable } from '@angular/core';
import { DEFAULT_LIMIT, type Paginated } from '@partou/core';
import { Observable, of } from 'rxjs';
import { MOCK_LOCATIONS_LIST } from '../constants/mock-locations.const';

@Injectable()
export class MockLocationsApiService {
  getLocations(query: LocationsQuery = {}): Observable<Paginated<Location>> {
    const search: string = (query.nameSearch ?? '').trim().toLocaleLowerCase('nl');
    const matched: ReadonlyArray<Location> =
      search === ''
        ? MOCK_LOCATIONS_LIST
        : MOCK_LOCATIONS_LIST.filter((location: Location): boolean =>
            location.name.toLocaleLowerCase('nl').includes(search),
          );
    const offset: number = query.offset ?? 0;
    const limit: number = query.limit ?? DEFAULT_LIMIT;
    return of({ items: matched.slice(offset, offset + limit), total: matched.length });
  }
}
